import React, {useEffect, useState} from 'react';
import { FaStar } from 'react-icons/fa';
import PropTypes from 'prop-types';

const Rating = ({ count, value, filledColor, hoverColor = filledColor, color, onChange, disableHover = false, size = 30 }) => {
    const convertValueForStar = (value) => {
        return (value/100)*count;
    };

    const [hoverRating, setHoverRating] = useState(0);

    useEffect(() => {
        setHoverRating(convertValueForStar(value));
    }, [value]);

    const onMouseEnter = (index) => {
        if (disableHover) return;
        setHoverRating(index);
    };

    const onMouseLeave = () => {
        if (disableHover) return;
        setHoverRating(convertValueForStar(value));
    };

    const onSaveRating = (index) => {
        onChange((index*100)/count);
    };

    const handleClick = (event) => {
        event.stopPropagation();
    };

    return (
        <div onClick={handleClick}>
            {Array.from({ length: count }, (_, index) => index + 1).map((star) => {
                const fill = hoverRating >= star ? hoverColor : color;
                const stroke = hoverRating >= star ? hoverColor : filledColor;
                return (
                    <FaStar
                        key={star}
                        aria-label={`Rate ${(100/count)*star}%`}
                        size={size}
                        onMouseEnter={() => onMouseEnter(star)}
                        onMouseLeave={onMouseLeave}
                        onClick={() => onSaveRating(star)}
                        color={fill}
                        style={{
                            paddingRight: 5,
                            cursor: 'pointer',
                            stroke: stroke,
                            strokeWidth: 40,
                        }}
                    />
                );
            })}
        </div>
    );
};

Rating.propTypes = {
    count: PropTypes.number.isRequired, // Nombre total d'étoiles
    value: PropTypes.number.isRequired, // La note actuelle en pourcentage
    filledColor: PropTypes.string, // Couleur des étoiles remplies
    color: PropTypes.string, // Couleur de base des étoiles
    onChange: PropTypes.func.isRequired // Fonction appelée lorsque la note change
};

Rating.defaultProps = {
    count: 5,
    value: 0,
    filledColor: 'black',
    color: 'white'
};

export default Rating;
